export default "__VITE_ASSET__7yXK$mXT__"